// Supprimer l'écran d'attente HTML
document.getElementById("early-message")?.remove();

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "shepherd.js/dist/css/shepherd.css";

import { WagmiConfig } from "wagmi";
import { wagmiConfig } from "./lib/wagmi";

import "./lib/appKit";
import { ThemeProvider } from "@material-tailwind/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// ✅ Import direct de App (au lieu de lazy)
import App from "./App";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <WagmiConfig config={wagmiConfig}>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </WagmiConfig>
      </ThemeProvider>
    </HelmetProvider>
  </StrictMode>
);
